import { ArcRoutes } from '../../pages/arc/constants/routes';
import { GpsType } from '../components/layout/layout-models';
import { useGpsType } from '../hooks/useGpsType';
import { DemographicAppKeys } from '../models/demographics-model';
import { getGpsTypeByCompPath, getGpsTypeByEmploymentPath } from './routing';

export const getGpsType = (gpsType: GpsType, app: DemographicAppKeys) => {
    let gpsTypeCopy = gpsType;
    const currentLocation = window?.location?.pathname;

    if (gpsType === GpsType.NONE) {
        if (currentLocation?.includes(`${ArcRoutes.Compensation}`)) {
            gpsTypeCopy = getGpsTypeByCompPath();
        } else if (currentLocation?.includes(`${ArcRoutes.Employment}`)) {
            gpsTypeCopy = getGpsTypeByEmploymentPath();
        }
    }

    return useGpsType(gpsTypeCopy, app);
};